import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

// Group-related actions
export const getGroupNameLibAsync = createAsyncThunk(
  'group/fetch-all-groups',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'v2/rbac-config/fetch-all-groups', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const getGroupsByUserLibAsync = createAsyncThunk(
  'group/fetch-groups-by-user',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/fetch-groups-by-user', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const createGroupLibAsync = createAsyncThunk(
  'group/create-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/create-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)

export const removeGroupLibAsync = createAsyncThunk(
  'group/remove-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/remove-group-from-user', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg:true,
    })
  }
)

export const assignUserToGroupLibAsync = createAsyncThunk(
  'group/assign-user-to-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/assign-user-to-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg:true,
    })
  }
)

export const assignRoleToGroupLibAsync = createAsyncThunk(
  'group/assign-role-to-group',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v2/rbac-config/assign-role-to-group', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  }
)
